var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    className: "strokeToggle",
    id: "Drei-Teilpensionierungen",
    transform: "translate(-312.000000, -686.000000)",
    stroke: "#145685",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teilpensionierung-20%",
    transform: "translate(268.000000, 562.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    transform: "translate(45.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 4 2 4 18 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4 L16,18 C16,19.1045695 15.1045695,20 14,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,4 M5,4 L5,2 C5,0.8954305 5.8954305,0 7,0 L11,0 C12.1045695,0 13,0.8954305 13,2 L13,4",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 7,
    y2: 15,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 9,
    x2: 11,
    y2: 15,
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6ba1b190d6dfefcb240236997d4fa1d7.svg";
export { ForwardRef as ReactComponent };